import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as AppPropTypes from '../../../lib/PropTypes';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import Button from '../../buttons/Button';

import styles from '../../../../styles/displays/sidebars/default-sidebar.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    game: AppPropTypes.game,
    changeStep: PropTypes.func.isRequired,
    className: PropTypes.string,
};

const defaultProps = { game: null, className: null };

function DefaultSidebar({ page, game, changeStep, className }) {
    const themeClassName = useThemeClassName(styles);

    const { pageStep = null, pageSteps = [] } = page || {};
    const { slug: currentSlug = null } = pageStep || {};

    const { step: stepId = null, id: gameId = null } = game || {};
    const stepParts = stepId !== null ? stepId.split('-') : null;
    const questionId = stepParts !== null && stepParts.length > 1 ? stepParts[1] : null;

    const finalSteps = useMemo(
        () =>
            (pageSteps || [])
                .map((item) => {
                    const { hideInMenu = false } = item || {};
                    if (hideInMenu) {
                        return null;
                    }
                    return item;
                })
                .filter((it) => it !== null)
                .filter((it) => {
                    if (gameId !== null) {
                        return true;
                    }
                    return it.id === 'start' || it.id === 'games' || it.id === 'wait';
                }),
        [pageSteps, gameId],
    );

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className,
                },
            ])}
        >
            {finalSteps.map(({ id, label, slug }, index) => (
                <div
                    key={`step-${id}-${index + 1}`}
                    className={classNames([
                        styles.item,
                        {
                            [styles.active]:
                                slug === currentSlug ||
                                (slug === `question-${questionId}` &&
                                    currentSlug === `leaderboard-${questionId}`),
                        },
                    ])}
                >
                    <Button className={styles.link} onClick={() => changeStep(slug, gameId)}>
                        {label}
                    </Button>
                </div>
            ))}
        </div>
    );
}

DefaultSidebar.propTypes = propTypes;
DefaultSidebar.defaultProps = defaultProps;

export default DefaultSidebar;
